import Helper from "./helper";

/**
 *
 * This function checks locationData response for commissionJunctionRules configuration.
 * for all products have boolean property aside from campaigns which have arrays of business category id to check
 *
 *
 * @param {object} locationData = response from locationData API that will be used to extract the object of `commisionRuleJunction`
 * @param {string} [paymentType] = optional parameter that is used, currently, to track `payWithPoints`. In relation to the commissionJunctionRule
 *
 */

export const commissionJunctionRules = (locationData, paymentType) => {
  let appendCJRule = "";
  const commissionRulesObj = locationData?.cjRules;
  const cjQueryParameters = commissionRulesObj?.queryParameters;
  const {
    teltomID,
    expressCheckoutID,
    renewalCheckoutID,
    priceLevel,
    businessCategoryID,
  } = cjQueryParameters;

  const commissionJunction = commissionRulesObj?.commissionRules;

  const businessProperties =
    JSON.parse(localStorage.getItem("businessProperties")) || [];

  const salesTypeId = businessProperties?.find(
    (businessProperty) => businessProperty.salesTypeId
  )?.salesTypeId;

  if (!locationData || !Object.keys(commissionJunction).length) {
    return appendCJRule;
  }

  const currentQueryLocation = new URLSearchParams(window.location?.search);
  const locationPath = window.location.pathname;
  const businessCategoryId = currentQueryLocation.get(businessCategoryID);
  const teltomId = currentQueryLocation.get(teltomID);
  const expressCheckoutId = locationPath
    .toLowerCase()
    .includes(expressCheckoutID);
  const renewalId = locationPath.toLowerCase().includes(renewalCheckoutID);
  const paymentTypeSanitize = paymentType?.replace(/ /g, "").toLowerCase();
  const affiliateKeyText = currentQueryLocation.get(priceLevel);

  const affiliatesList = commissionJunction?.affiliate?.affiliatesList || [];
  const campaigns = commissionJunction?.campaign?.campaign_bc || [];
  const qbrBusinessCategory = commissionJunction.partnership.qbr_bc;

  /*
   * checking all keys of commissionJunction from BE;
   */
  for (let commission in commissionJunction) {
    switch (commission) {
      case "partnership":
        if (
          (salesTypeId === "1" ||
            salesTypeId === "3" ||
            Number(qbrBusinessCategory) === Number(businessCategoryId)) &&
          !campaigns.includes(Number(businessCategoryId))
        ) {
          return (appendCJRule = commissionJunction.partnership.gtmHash);
        }
        break;

      case "payWithPoints":
        if (paymentTypeSanitize === "paywithpoints") {
          return (appendCJRule = commissionJunction.payWithPoints);
        }
        break;

      case "hotelSale":
        if (Helper.hotelDetected())
          return (appendCJRule = commissionJunction.hotelSale);
        break;

      case "campaign":
        if (campaigns.includes(Number(businessCategoryId)))
          return (appendCJRule = commissionJunction.campaign.gtmHash);
        break;

      case "telTOM":
        if (teltomId) return (appendCJRule = commissionJunction.telTOM);
        break;

      case "renewal":
        if (renewalId) return (appendCJRule = commissionJunction.renewal);
        break;

      case "expressCheckout":
        if (expressCheckoutId)
          return (appendCJRule = commissionJunction.expressCheckout);
        break;

      case "affiliate":
        if (affiliatesList.includes(affiliateKeyText)) {
          return (appendCJRule = commissionJunction.affiliate.gtmHash);
        }
        break;

      default:
        appendCJRule = commissionJunction.publicSale;
    }
  }
  return appendCJRule;
};
